import React from 'react';
import { Tag } from '../../types/tags';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import TagDisplay from './index';

export default function PartsTagDisplay({
	tags = [],
	className = '',
	darkMode = false,
}: {
	tags: Tag[];
	className?: string;
	darkMode?: boolean;
}) {
	if (nullSafeGet('length', tags) < 1) {
		return null;
	}

	return (
		<div className={`flex flex-row flex-wrap items-center gap-x-4 gap-y-2 ${className}`}>
			{tags.map((tag) => (
				<TagDisplay tag={tag} key={tag.id} darkMode={darkMode} />
			))}
		</div>
	);
}
